import { formatPrice } from '@vy/services';
import { CREDIT_KINDS, type Currency } from '@vy/types';
import { formatNumber } from '@vy/utils';

export function formatCreditAmount(
  amount: number,
  creditKind: string,
  currency: Currency,
  units?: string,
): string {
  if (creditKind === CREDIT_KINDS.MONETARY) {
    return formatPrice(amount, currency);
  }

  return `${formatNumber(amount)} ${units ?? 'units'}`;
}
